module.exports = __webpack_public_path__ + "static/media/trend-data-graph.66f66622.png";